export default () => [
    { value: 21, label: '21' },
    { value: 30, label: '30' },
    { value: 60, label: '60' },
]
